<script>
    export default {
        props: {
            // 动画运行状态
            waveStatus: {
                type: Boolean,
                default: true
            }
        }
    }
</script>

<template>
    <!-- 波浪效果 -->
    <view class="wave-wrapper wave-animation">
        <view class="wave-wrapper-inner bg-top">
            <view class="wave wave-top"/>
        </view>
        <view class="wave-wrapper-inner bg-middle">
            <view class="wave wave-middle" :class="waveStatus ? 'run' : 'pause'"/>
        </view>
        <view class="wave-wrapper-inner bg-bottom">
            <view class="wave wave-bottom" :class="waveStatus ? 'run' : 'pause'"/>
        </view>
    </view>
</template>

<style scoped>
    .wave-wrapper {
        width: 100%;
        height: 56px;
        overflow: hidden;
        position: relative;
        background-color: #009251;
    }

    .wave-wrapper-inner {
        width: 100%;
        height: 100%;
        bottom: -1px;
        overflow: hidden;
        position: absolute;
    }

    .bg-top {
        z-index: 15;
        opacity: 0.5;
        background-color: #009251;
    }

    .bg-middle {
        z-index: 10;
        opacity: 0.75;
        background-color: #009251;
    }

    .bg-bottom {
        z-index: 5;
        background-color: #009251;
    }

    .wave {
        left: 0;
        width: 200%;
        height: 100%;
        position: absolute;
        background-position: 0 bottom;
        transform-origin: center bottom;
        background-repeat: repeat no-repeat;
    }

    .wave-top {
        background-size: 50% 23px;
        background-image: url('../assets/images/wave-top.png');
    }

    .wave-animation .wave-top {
        animation-delay: 1s;
        animation: move-wave 3s;
        -webkit-animation-delay: 1s;
        -webkit-animation: move-wave 3s;
    }

    .wave-middle {
        background-size: 50% 32px;
        animation: move_wave 7s linear infinite;
        background-image: url('../assets/images/wave-mid.png');
    }

    .wave-animation .wave-middle {
        animation: move_wave 7s linear infinite;
    }

    .wave-bottom {
        background-size: 50% 43px;
        background-image: url('../assets/images/wave-bot.png');
    }

    .wave-animation .wave-bottom {
        animation: move_wave 12s linear infinite;
    }

    .wave-animation .pause {
        animation-play-state: paused;
    }

    .wave-animation .run {
        animation-play-state: running;
    }

    @keyframes move_wave {
        0% {
            transform: translateX(0) translateZ(0) scaleY(1);
        }

        50% {
            transform: translateX(-25%) translateZ(0) scaleY(0.55);
        }

        100% {
            transform: translateX(-50%) translateZ(0) scaleY(1);
        }
    }
</style>
